<div class="d-flex justify-content-center align-items-center flex-column" style="width: 100%; height: 100%">
  <h1 class="text-warning">Oops!</h1>
  <br />
  <h3 class="text-warning">your workspace wasn't upgraded!</h3>
  <h4 class="warning">If you believe this is a mistake, please contact our customer support!</h4>

  <br />
  <br />
  <br />
  <button nbButton status="primary" (click)="navigateWorkspace()">Back to workspace</button>
</div>
